export const checkLikedByUser = (thispost,loggedInUser) => thispost.likes?.likedBy.some(ele => ele.username === loggedInUser.username);